module.exports = __webpack_public_path__ + "img/btn-coupon-1.cd3430eb.png";